import * as Yup from 'yup';
import {
  getOpenFirstAndLastPointsFromWKT,
  WKT_GEOMETRY_REGEX,
} from '../utils/dataImport.validators';

export type IWktGeometryFormValues = {
  wkt?: string | null;
};

export const wktGeometrySchema = Yup.object().shape({
  wkt: Yup.string()
    .default('')
    .nullable()
    .test(
      'wkt-validation',
      'Data cannot be read. Please make sure to use valid WKT. We support points, polygons, and multipolygons.',
      (value?: string | null) => {
        if (!value) {
          return true;
        }
        return WKT_GEOMETRY_REGEX.some(regex => regex.test(value.trim()));
      }
    )
    .test(
      'wkt-polygon-open',
      'The polygon WKT seems to be not closed. Please make sure the first and last coordinates are the same.',
      (value?: string | null) => getOpenFirstAndLastPointsFromWKT(value).length === 0
    ),
}) as Yup.ObjectSchema<IWktGeometryFormValues>;
